import { RenderTokenExport } from '../hsdatatokens/shared';
import { getHsDataTokenSettings } from '../hsdatatokens/utils';
import { addPreProcessTransform, addPostProcessTransform, replaceNodes, parseHtml } from '../utils/transformer';
export const AI_DYNAMIC_TOKEN_CATEGORY = 'ai_dynamic_token';

// Pattern to match dynamic text tokens: {{ ai_dynamic_token(promptId) }}
const AI_DYNAMIC_TOKEN_PATTERN = /{{-?\s*ai_dynamic_token\(\s*["']?([\w_]+)["']?\s*\)\s*-?}}/g;
export const replaceHubLWithDynamicTextToken = (textContent, editor) => {
  let newTextContent = textContent;
  const dataTokenConfig = getHsDataTokenSettings(editor);
  if (!dataTokenConfig) {
    return newTextContent;
  }
  newTextContent = newTextContent.replace(AI_DYNAMIC_TOKEN_PATTERN, (fullMatch, tokenId) => {
    const fullPath = `${AI_DYNAMIC_TOKEN_CATEGORY}.${tokenId}`;
    const renderedToken = RenderTokenExport.renderToken(dataTokenConfig)({
      path: fullPath,
      category: AI_DYNAMIC_TOKEN_CATEGORY
    });
    if (!renderedToken) {
      return fullMatch;
    }
    return renderedToken.nodeType === Node.ELEMENT_NODE ? renderedToken.outerHTML : renderedToken.textContent || fullMatch;
  });
  return newTextContent;
};
export const addDynamicTextTokenTransforms = editor => {
  const replaceHubLWithPlaceholder = tokenNode => {
    const newTextContent = replaceHubLWithDynamicTextToken(tokenNode.textContent || '', editor);
    const doc = parseHtml(`<div>${newTextContent}</div>`);
    const firstChild = doc.body.firstChild;
    return firstChild && firstChild.childNodes;
  };
  addPreProcessTransform(editor, dom => {
    const textNodeIterator = dom.createNodeIterator(dom.body, NodeFilter.SHOW_TEXT, node => {
      AI_DYNAMIC_TOKEN_PATTERN.lastIndex = 0;
      const nodeTextContent = node.textContent || '';
      const hasPattern = AI_DYNAMIC_TOKEN_PATTERN.test(nodeTextContent);
      return hasPattern ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    });
    const textNodes = [];
    let currentNode = textNodeIterator.nextNode();
    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = textNodeIterator.nextNode();
    }
    if (textNodes.length > 0) {
      replaceNodes(textNodes, replaceHubLWithPlaceholder);
    }
  });
  addPostProcessTransform(editor, dom => {
    const tokenPlaceholderNodes = dom.querySelectorAll(`[data-mce-property-category="${AI_DYNAMIC_TOKEN_CATEGORY}"]`);
    replaceNodes(tokenPlaceholderNodes, RenderTokenExport.replacePlaceholderWithHubl());
  });
};
export const getUpdateAlreadyRenderedDynamicTextToken = editor => token => {
  const dataTokenConfig = getHsDataTokenSettings(editor);
  if (!dataTokenConfig) {
    return;
  }
  const path = token.getAttribute('data-mce-token-path') || '';
  const placeholderNode = RenderTokenExport.renderToken(dataTokenConfig)({
    path,
    category: AI_DYNAMIC_TOKEN_CATEGORY
  });
  const parentNode = token.parentNode;
  if (parentNode && placeholderNode) {
    parentNode.replaceChild(placeholderNode, token);
  }
};
export const handleDynamicTextTokensLoaded = editor => {
  const body = editor.getBody();
  if (body) {
    // Check for text nodes with dynamic text patterns
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => {
        AI_DYNAMIC_TOKEN_PATTERN.lastIndex = 0;
        const hasPattern = AI_DYNAMIC_TOKEN_PATTERN.test(node.textContent || '');
        return hasPattern ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const textNodes = [];
    let currentNode = walker.nextNode();
    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = walker.nextNode();
    }

    // Process text nodes containing patterns with rendered tokens
    textNodes.forEach(node => {
      if (node.parentNode) {
        const originalContent = node.textContent || '';
        const newContent = replaceHubLWithDynamicTextToken(originalContent, editor);
        if (newContent !== originalContent) {
          const doc = parseHtml(`<div>${newContent}</div>`);
          const firstChild = doc.body.firstChild;
          if (firstChild && firstChild.childNodes) {
            const parent = node.parentNode;
            // Replace the text node with the rendered content
            Array.from(firstChild.childNodes).forEach(childNode => {
              parent.insertBefore(childNode, node);
            });
            parent.removeChild(node);
          }
        }
      }
    });
    const alreadyRenderedTokens = Array.from(body.querySelectorAll(`[data-mce-property-category="${AI_DYNAMIC_TOKEN_CATEGORY}"]`));
    const updateToken = getUpdateAlreadyRenderedDynamicTextToken(editor);
    alreadyRenderedTokens.forEach(updateToken);
  }
};